import React, { useState } from 'react';
import {
  VertModal, VertButton, Spin, Row
} from '@vertem-core/vertice-ds';
import PreviewPDF from 'components/PreviewPDF';

interface AcceptTermsModalProps {
  visible?: boolean;
  onClose: () => void;
  onAgree: () => void;
  urlPDF: string,
  title?: string;
  message?: string;
}

const AcceptTermsModal = ({
  visible=false,
  urlPDF='',
  title = 'Termos de uso',
  message = 'Li e aceito o regulamento da campanha.',
  onAgree,
  onClose
}: AcceptTermsModalProps) => {
    
  const [isLoading, setLoading] = useState(false);

  React.useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [visible]);

  const CheckProtocol = (url: any) => {
    const hasHttp = url.startsWith('http://');
    const hasHttps = url.startsWith('https://');

    if (hasHttp || hasHttps) {
      return url;
    }

    return `https://s3.amazonaws.com/${url}`;
  };

  return (
    <VertModal
      open={visible}
      maskClosable={false}
      onCancel={() => {
        if (onClose) {
          onClose();
        }
      }}
      width="96%"
      style={{ 
        maxWidth: '800px', 
        height: 'calc(100vh - 20px)', 
        top: 0, 
        padding: 0,
        margin: 0 
      }}
      bodyStyle={{
        height: 'calc(100vh - 100px)',
        padding: 24,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Row 
        gutter={10} 
        className="padding-x-regular padding-y-regular"
        style={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <div
          style={{ 
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div 
            className="regulations-collapse-container"
            style={{ flex: 1, minHeight: 0 }}
          >
            <div 
              className="regulation-list"
              style={{ height: '100%' }}
            >
              <PreviewPDF urlPDF={CheckProtocol(urlPDF)} />
            </div>
          </div>
          
          <VertButton
            style={{ width: '100%', marginTop: '16px' }}
            disabled={isLoading}
            onClick={onAgree}
          >
            {isLoading ? <Spin /> : message}
          </VertButton>
        </div>
      </Row>
    </VertModal>
  );
};

export default AcceptTermsModal;
